module.exports = __webpack_public_path__ + "static/media/PS-04.050a7aa9.svg";